import _ from "lodash";
import {Konfigurasjon} from "felles/infrastruktur/Konfigurasjon";

export function serviceUrlFilterForInjisering() {
    return [Konfigurasjon.regNavn, serviceUrlFilter];
}

export function serviceUrlFilter(konfigurasjon: Konfigurasjon): Function {
    return function (url: string) {
        if (_.isUndefined(url)) return '';
        var urlMedServiceRot = konfigurasjon.serviceRotUrl + url;
        return urlMedServiceRot;
    };
}

